'use client'
import {heroSectionData} from 'content/for-founders-it-hr-and-admins'
import classes from './styles.module.css'
import {useState} from 'react'
import HeroLayoutWithImage from 'v1/common-components/hero-layout-with-image/HeroLayoutWithImage'
import {BoldTextWithAsterisks} from 'v1/page-components/marketing/free-trial/main/Main'
import Button from 'v1/common-components/button/Button'
import {DemoData} from 'v1/types/home-page'
import Image from 'next/image'
import clsx from 'clsx'
import Modal from 'v1/common-components/modal/Modal'
import BookDemoForm from 'v1/page-components/marketing/common/demo-form/BookDemoForm'
import ArrowRightIcon from 'v1/assets/icons/arrow-right.svg'

const defaultDemoData = {
  isNameRequired: true,
  heading: 'Book a demo',
  buttonText: 'Book a demo',
}

export default function Hero() {
  const [isModalOpen, setModalOpen] = useState<boolean>(false)
  const [demoData, setDemoData] = useState<DemoData>({...defaultDemoData})

  const toggleModal = (data: DemoData | null = null) => {
    setDemoData(
      data || {
        ...defaultDemoData,
      },
    )
    setModalOpen(prev => !prev)
  }

  return (
    <>
      <HeroLayoutWithImage
        ImageSrc={heroSectionData.image}
        mobileHeroImage={heroSectionData.mobileImage}
        heroContainerClass={classes.heroContainer}
        leftTextBox={
          <div className={classes.topLeftText}>
            <h1 className={clsx('h2-v1', classes.title)}>{heroSectionData.title}</h1>
            <div className={classes.topParaTextContainer}>
              <p className={clsx('paragraph1-v1', classes.textSecondary)}>
                <BoldTextWithAsterisks text={heroSectionData.paragraph} />
              </p>
            </div>
            <div className={classes.actions}>
              <Button
                onClick={() => toggleModal()}
                // text={heroSectionData.btnText}
                text="Book a demo"
                style={{gap: '12px', borderRadius: '16px', padding: '12px 24px'}}
                isAnimate={true}
                iconRight={
                  <span className={classes.btnIconBox}>
                    <Image src={ArrowRightIcon} alt="login-icon" width={24} height={24} />
                  </span>
                }
              />
              {/* <Button
                variant="custom"
                text="Book a demo"
                onClick={() => toggleModal({})}
                style={{gap: '12px', borderRadius: '16px'}}
                className={clsx(classes.bookDemoBtn)}
              /> */}
            </div>
          </div>
        }
      />
      <Modal isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
        <BookDemoForm data={demoData} />
      </Modal>
    </>
  )
}
